import React from 'react'
import { getPageByCodename, SingleItemResponse } from '@lib/kontent'
import { GetStaticProps, NextPage } from 'next'
import { NewWatches2020 } from '@components/_rolex/NewWatches2020'
import { RolexNewWatches2020Live } from '@lib/kontent/models/RolexNewWatches2020Live'

type Props = SingleItemResponse<RolexNewWatches2020Live>

const NewWatches: NextPage<Props> = props => <NewWatches2020 {...props} />

export const getStaticProps: GetStaticProps = async ({ preview, params }) => {
  try {
    const langParam =
      params && params.lang
        ? typeof params.lang === 'string'
          ? params.lang
          : params.lang.pop()
        : 'nl'
    const language = langParam === 'sg' ? 'en' : langParam
    const content = await getPageByCodename<RolexNewWatches2020Live>({
      codename: 'new_watches_2020___live',
      lang: language,
      preview
    })

    return {
      props: {
        ...content
      }
    }
  } catch (error) {
    throw error
  }
}

export const getStaticPaths = () => {
  return {
    fallback: false,
    paths: [{ params: { lang: 'en' } }, { params: { lang: 'sg' } }]
  }
}

export default NewWatches
